import Validate from "./Validate.js";
import { scrollToElement, loadLibrary, isInViewportArea, debounce } from "./Util.js";
import { LIB_URL } from './App';

class Form {
    constructor(form) {
        this.$form = $(form);
        this.$btn = this.$form.find(".js-submit");
        this.recaptchaSitekey = '6LdizMwrAAAAABf2qiyXdOWvf6ZuYyIXgdhAjCoH';
        this.validateObj = new Validate(this.$form);
        this.recaptchaReady = false;

        this.popLabels();
        this.fileUpload();
        this.filterPhone();
        this.disableIEautocomplete();

        this.hasRecaptcha = Boolean(this.$form.find(".js-recaptcha").data('sitekey'));

        if (this.hasRecaptcha) {
            this.loadRecaptcha().then(() => {
                this.recaptchaReady = true;
                console.log('reCAPTCHA loaded and ready');
            }).catch(() => {
                console.warn('Failed to load reCAPTCHA');
            });
        }

        this.bindSubmit();
        this.bindClose();
    }

    // Подсказки для инпутов
    popLabels() {
        const validateForm = this.validateObj;
        const $formBtn = this.$btn;

        this.$form
            .find(".js-input, .js-textarea")
            .on("input blur", function () {
                const val = $.trim($(this).val());

                if (!val.length || val == "+7() --") {
                    $(this).closest(".js-input-wrap").removeClass("_focused");
                } else {
                    $(this).closest(".js-input-wrap").addClass("_focused");

                    if (validateForm.validateAllFieldsNotEmpty()) {
                        validateForm.calculateErrors();
                    }
                }

                if ($(this).hasClass("js-textarea")) {
                    textareaCounter($(this));
                }
            });

        this.$form.find(".js-input, .js-textarea").each(function () {
            const val = $.trim($(this).val());

            if (!val.length || val == "+7() --") {
                $(this).closest(".js-input-wrap").removeClass("_focused");
            } else {
                $(this).closest(".js-input-wrap").addClass("_focused");

                if (validateForm.validateAllFieldsNotEmpty()) {
                    $formBtn.removeAttr("disabled");
                }
            }

            if ($(this).hasClass("js-textarea")) {
                textareaCounter($(this));
            }
        });

        if ($(".js-select").length) {
            $(".js-select").each(function () {
                if ($(this).val().length > 0) {
                    $(this).closest(".js-input-wrap").addClass("_focused");
                } else {
                    $(this).closest(".js-input-wrap").removeClass("_focused");
                }

                $(this).on("select2:select", function () {
                    if ($(this).val().length > 0) {
                        $(this).closest(".js-input-wrap").addClass("_focused");
                    } else {
                        $(this)
                            .closest(".js-input-wrap")
                            .removeClass("_focused");
                    }
                });
            });
        }
    }

    // Закрытие формы
    bindClose() {
        App.H.find(".js-form-ok").on("click", function (e) {
            e.preventDefault();
            App.H.removeClass("_form-success _form-error _form-message");
        });
    }

    // Загрузка файла
    fileUpload() {
        this.$form.find(".js-upload").on("change", function () {
            const $input = $(this);
            const $label = $input
                .closest(".input-wrap")
                .find(".js-upload-label");
            const val = $input.val();
            let fileName;

            if (val.length) {
                fileName = val.split("\\").pop() || "";
                $label.text(fileName);
                $input.addClass("_active");
            } else {
                $label.text($label.data("text"));
                $input.removeClass("_active");
            }
        });

        this.$form.find(".js-upload-clear").on("click", function () {
            $(this).siblings(".js-upload").val("").change();
        });
    }

    // Для поля телефона допускаем только цифры, пробел и +-()
    filterPhone() {
        this.$form.find("[data-phone]").on("input", function () {
            const val = $(this)
                .val()
                .replace(/[^0-9\s()+-]/g, "");
            $(this).val(val);
        });
    }

    // Фикс autocomplete="off" для IE и Edge
    disableIEautocomplete() {
        if (App.ie || App.edge) {
            window.onbeforeunload = function () {
                $('form[autocomplete="off"]').each(function () {
                    this.reset();
                });
            };
        }
    }

    loadRecaptcha() {
        return new Promise((resolve, reject) => {
            if (window.grecaptcha && grecaptcha.execute) {
                // Уже загружено
                resolve();
                return;
            }
            // Динамически загружаем скрипт
            const scriptSrc = `https://www.google.com/recaptcha/api.js?render=${this.recaptchaSitekey}`;
            $.getScript(scriptSrc)
                .done(() => {
                    grecaptcha.ready(() => resolve());
                })
                .fail(() => reject());
        });
    }

    bindSubmit() {
        this.$form.on("submit", async (e) => {
            e.preventDefault();
            this.$btn.attr("disabled", true);

            if (this.hasRecaptcha) {
                if (!this.recaptchaReady) {
                    console.log('Waiting for reCAPTCHA to load...');
                    // Можно отобразить сообщение или просто ждать
                    await this.loadRecaptcha();
                    this.recaptchaReady = true;
                }
                try {
                    const token = await grecaptcha.execute(this.recaptchaSitekey, {action: 'submit'});
                    this.$form.find('[name="g-recaptcha-response"]').remove();
                    this.$form.append(`<input type="hidden" name="g-recaptcha-response" value="${token}"/>`);
                    this.sendForm();
                } catch (err) {
                    console.error('reCAPTCHA error:', err);
                    this.$form.removeClass("_success").addClass("_error");
                    this.$btn.removeAttr("disabled");
                }
            } else {
                this.sendForm();
            }
        });
    }

    // Сброс формы
    resetForm() {
        this.$form[0].reset();

        this.$form
            .find(".js-upload")
            .val("")
            .change()
            .siblings("[data-label]")
            .text("");

        // this.$form.removeClass('_success _error');

        this.$form
            .find("[data-required]")
            .not(":checkbox")
            .addClass("_notvalidated")
            .removeClass("_error");

        this.$form
            .find(":checkbox[data-required]")
            .not(":checked")
            .addClass("_notvalidated");

        this.$form.find(".js-submit").attr("disabled", true);

        this.$form.find(".js-input-wrap").removeClass("_focused");

        this.$form.find(".js-dropdown").trigger("dropdown:reset");

        this.$form.find(".js-select").val(null).trigger("change");

        // Удаляем токен reCAPTCHA, если есть
        this.$form.find('[name="g-recaptcha-response"]').remove();
    }

    // Отправка
    sendForm() {
        if (!this.validateObj.validateAllFields()) {
            this.validateObj.calculateErrors();
            this.$btn.removeAttr("disabled");
            scrollToElement(
                this.$form
                    .parents(".js-trial-form-wrapper")
                    .find("._error")
                    .first()
            );
            return false;
        }

        this.$btn.addClass("_loading");
        this.$form.ajaxSubmit({
            url: this.$form.attr("action"),
            type: this.$form.attr("method") || "GET",
            cache: false,
            success: (response) => {
                if (!response.success) {
                    // Ошибка на сервере
                    this.$btn.removeClass("_loading");
                    this.$form
                        .removeClass("_form-success")
                        .addClass("_form-error _form-message");
                    this.$form.find(".js-error-message").addClass("_active");
                    this.$form.find(".js-error-message").text("");
                    this.$form
                        .find(".js-error-message")
                        .prepend(response.message);

                    // Разблокируем кнопку
                    this.$btn.removeAttr("disabled");
                } else {
                    // Успех!
                    this.$btn.removeClass("_loading");
                    if (this.$form.hasClass("auth-form")) {
                        window.location.href = response.redirect_to;
                    }

                    this.resetForm();

                    if (this.$form.closest('.webinar-form').find('.webinar').length) {
                        this.$form
                            .closest('.webinar-form')
                            .find('.title-h4')
                            .hide();
                    }

                    this.$form
                        .removeClass("_form-error")
                        .addClass("_form-success _form-message");
                    this.$form.find(".js-error-message").removeClass("_active");
                    this.$form.find(".js-error-message").text("");

                    this.$btn.removeAttr("disabled");
                    this.$form.find(".js-select").removeClass("_error");
                    this.$form
                        .find(".form-item-wrap-select")
                        .find(".form__error")
                        .text("");

                    this.$form
                        .parents(".js-trial-form-wrapper")
                        .addClass("success-form");

                    this.$form
                        .parents(".js-trial-form-wrapper")
                        .find(".js-form-success-message")
                        .addClass("_active");
                    this.$form
                        .parents(".js-trial-form-wrapper")
                        .find(".js-form-success-message")
                        .find(".js-form-success-message__title")
                        .text("");
                    this.$form
                        .parents(".js-trial-form-wrapper")
                        .find(".js-form-success-message")
                        .find(".js-form-success-message__title")
                        .prepend(response.message);

                    if (this.$form.hasClass("form-contacts")) {
                        this.$form.addClass("_success-form");

                        this.$form
                            .siblings(".js-form-success-message")
                            .addClass("_active");
                        this.$form
                            .parents(".js-trial-form-wrapper")
                            .find(".js-form-success-message")
                            .find(".js-form-success-message__title")
                            .text("");
                        this.$form
                            .siblings(".js-form-success-message")
                            .find(".js-form-success-message__title")
                            .prepend(response.message);
                        this.$form
                            .closest(".form-contacts-wrap")
                            .find("h1")
                            .hide();
                    }

                    if (
                        this.$form
                            .closest(".js-trial-form-wrapper")
                            .hasClass("js-past-webinars-from-wrapper")
                    ) {
                        this.$form
                            .closest(".js-trial-form-wrapper")
                            .addClass("_hidden");
                        App.D.find(".js-past-webinars")
                            .removeClass("_hidden")
                            .find(".wrap")
                            .append(response.content);
                        document.cookie = "pastWebinarsShown=true";
                    }

                    if (response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    }
                }

                // Автоматически закрываем сообщения
                if (!this.$form.closest(".webinar-form").length) {
                    setTimeout(() => {
                        this.$form.removeClass(
                            "_form-success _form-error _form-message"
                        );
                    }, 3000);
                }
            },
            error: () => {
                // Ошибка отправки

                this.$form
                    .removeClass("_form-success")
                    .addClass("_form-error _form-message");

                console.log("Ошибка отправки формы");

                // Разблокируем кнопку
                this.$btn.removeAttr("disabled");

                // Автоматически закрываем сообщения
                setTimeout(() => {
                    this.$form.removeClass(
                        "_form-success _form-error _form-message"
                    );
                }, 10000);
            },
        });
    }
}

const loadedForms = new WeakSet();

export function loadCaptchaScript($form) {
    if ($form.length === 0) return;

    if (loadedForms.has($form[0])) {
        // Уже инициализировали
        return;
    }

    // Загружаем jquery.form.js асинхронно перед инициализацией формы
    loadLibrary(LIB_URL.JQ_FORM, () => {
        // Создаем экземпляр формы (в конструкторе загрузится капча асинхронно)
        new Form($form[0]);
        $form.addClass('_init');
        loadedForms.add($form[0]);
    });
}
